module.exports = __webpack_public_path__ + "img/purchase_2.178cc6c6.png";